import { useEffect, useState } from 'react';

type UseIsFixedProps = {
  containerRef?: React.RefObject<HTMLDivElement>;
  isHomePage?: boolean;
  isSmall?: boolean;
  headerId?: string;
};

export const useStickyHeader = ({
  containerRef,
  isHomePage = false,
  isSmall = false,
  headerId = 'popup_header'
}: UseIsFixedProps) => {
  const [isFixed, setIsFixed] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [showFloatButton, setShowFloatButton] = useState(false);
  const [isScrollLocked, setIsScrollLocked] = useState(false);

  const FIX_ON = 10;
  const FIX_OFF = 5;

  useEffect(() => {
    if (containerRef?.current && !isFixed) {
      setHeaderHeight(containerRef.current?.clientHeight);
    }
  }, [containerRef?.current?.clientHeight, isFixed]);

  useEffect(() => {
    if (!isSmall) return;

    const handleFocus = () => setIsScrollLocked(true);
    const handleBlur = () => setIsScrollLocked(false);

    window.addEventListener('focusin', handleFocus);
    window.addEventListener('focusout', handleBlur);

    return () => {
      window.removeEventListener('focusin', handleFocus);
      window.removeEventListener('focusout', handleBlur);
    };
  }, [isSmall]);

  useEffect(() => {
    const scrollHandler = () => {
      if (isHomePage && !isSmall) return;

      const scrollY = window.pageYOffset;

      const threshold =
        !isHomePage && isSmall ? headerHeight + 20 : headerHeight + 100;

      if (!isFixed && scrollY > threshold + FIX_ON && !isScrollLocked) {
        setIsFixed(true);
      } else if (isFixed && scrollY < threshold - FIX_OFF) {
        setIsFixed(false);
      }

      setShowFloatButton(scrollY > 300);
    };

    window.addEventListener('scroll', scrollHandler);
    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, [headerHeight, isFixed, isHomePage, isSmall, isScrollLocked]);

  useEffect(() => {
    const topHeader = document.getElementById(headerId);
    if (!topHeader) return;

    if (isFixed) {
      topHeader.style.opacity = '0';
      topHeader.style.pointerEvents = 'none';
    } else {
      topHeader.style.opacity = '1';
      topHeader.style.pointerEvents = '';
    }
  }, [isFixed, headerId]);

  return { isFixed, headerHeight, showFloatButton };
};
